// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kLjvB","signatureBlock":"Footer_signatureBlock__1OLY5","signature":"Footer_signature__3AOex"};